import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'debtNumber',
})
export class DebtNumberPipe implements PipeTransform {
  transform(value: number): string {
    return value
      .toString()
      .match(/\d{4}/g)
      .join('-');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/debt-number.pipe.ts